<div class="col-lg-3">
  <div class="detail-tile">
    <h3>{{folderName}}.</h3>
    @for (file of folderFiles; track file) {
      <div class="single-file">
        <div>
          <a (click)="downloadWarrantyConditions(folderName, file)">
            <i class="fa fa-file-pdf-o" aria-hidden="true"></i>{{file.replace(".pdf", "").toUpperCase()}}
          </a>
          @if (isAdmin()) {
            <a class="delete" (click)="deleteFile(folderName, file)">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18">
                <path fill="#92A2BD" fill-rule="nonzero"
                  d="M1 16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v10zm3.17-7.83a.996.996 0 0 1 1.41 0L7 9.59l1.42-1.42a.996.996 0 1 1 1.41 1.41L8.41 11l1.42 1.42a.996.996 0 1 1-1.41 1.41L7 12.41l-1.42 1.42a.996.996 0 1 1-1.41-1.41L5.59 11 4.17 9.58a.996.996 0 0 1 0-1.41zM10.5 1L9.79.29C9.61.11 9.35 0 9.09 0H4.91c-.26 0-.52.11-.7.29L3.5 1H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.5z"/>
                </svg>
              </a>
            }
          </div>
        </div>
      }
    </div>
    <div style="font-size:2px;">&nbsp;</div>
    @if (isAdmin()) {
      <div class="container" appFileDnD (fileDropped)="onFileDropped($event)">
        <input type="file" #fileDropRef id="fileDropRef" multiple accept="application/pdf"
          (change)="fileBrowseHandler($event.target.files)"/>
          <h3>{{'' | i18n: 'warranty-condition-drag-drop'}}</h3><br/>
          <label for="fileDropRef">Browse</label>
        </div>
      }

    </div>
